import {
  ASSIGNEE_TYPES,
  EDIT_PERMISSIONS,
  PERMISSION_TYPES,
  VIEW_PERMISSIONS,
} from '../constants';

export const DEFAULT_VIEW_PERMISSIONS = [VIEW_PERMISSIONS.VIEW_ONLY];

export const asArray = (value) => (Array.isArray(value) ? value : []);

export const normalizeAssignment = (entry = {}) => {
  const permissionModes = asArray(entry.permissionModes).length
    ? Array.from(new Set(entry.permissionModes))
    : [entry.permissionLevel === PERMISSION_TYPES.EDIT ? PERMISSION_TYPES.EDIT : PERMISSION_TYPES.VIEW];
  const modesWithView = permissionModes.includes(PERMISSION_TYPES.VIEW)
    ? permissionModes
    : [PERMISSION_TYPES.VIEW, ...permissionModes];
  const permissionLevel = modesWithView.includes(PERMISSION_TYPES.EDIT)
    ? PERMISSION_TYPES.EDIT
    : PERMISSION_TYPES.VIEW;
  return {
    ...entry,
    type: entry.type || ASSIGNEE_TYPES.USER,
    permissionLevel,
    permissionModes: modesWithView,
    editPermissions: asArray(entry.editPermissions).filter((key) => key !== EDIT_PERMISSIONS.ADD_WIDGET),
    viewPermissions: asArray(entry.viewPermissions).length
      ? Array.from(new Set([VIEW_PERMISSIONS.VIEW_ONLY, ...entry.viewPermissions]))
      : DEFAULT_VIEW_PERMISSIONS,
  };
};

export const assignmentAccessLevel = (entry, t) => {
  const normalized = normalizeAssignment(entry);
  const tags = [];
  if (normalized.permissionModes.includes(PERMISSION_TYPES.VIEW)) tags.push(t('share.confirmation.accessView'));
  if (normalized.permissionModes.includes(PERMISSION_TYPES.EDIT)) tags.push(t('share.confirmation.accessEdit'));
  if (normalized.permissionModes.includes(PERMISSION_TYPES.CREATE)) tags.push(t('share.confirmation.accessCreate'));
  return tags;
};

export const toSharedPayload = (assignment) => {
  const normalized = normalizeAssignment(assignment);
  return {
    type: normalized.type,
    id: normalized.id,
    name: normalized.name,
    role: normalized.role,
    userCount: normalized.userCount,
    permissionLevel: normalized.permissionLevel,
    permissionModes: normalized.permissionModes,
    editPermissions: normalized.editPermissions,
    viewPermissions: normalized.viewPermissions,
    permissions: normalized.permissionModes.includes(PERMISSION_TYPES.EDIT)
      ? [PERMISSION_TYPES.VIEW, PERMISSION_TYPES.EDIT]
      : [PERMISSION_TYPES.VIEW],
  };
};

export const userInitials = (name = '') =>
  name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
